import Model from './Model'
import get from 'lodash/get'
export default class EquipmentWorksheet extends Model {

    resource()
    {
        return 'equipment-worksheets'
    }

    get status_friendly() {
        return get(this.statuses.find(stat => stat.id === this.status), 'text')
    }

    get statuses () {
        return [{
            id: 'NEW',
            text: 'Nou'
        },{
            id: 'ACTIVE',
            text: 'Activ'
        },{
            id: 'PENDING_CUSTOMER',
            text: 'In Asteptare - Client'
        },{
            id: 'INVOICED',
            text: 'Facturat'
        },{
            id: 'FINALIZED',
            text: 'Finalizat'
        },{
            id: 'CANCELED',
            text: 'Anulat'
        }]
    }

    get types () {
        return [{
            value: 'SERVICE',
            text: 'Service'
        },{
            value: 'WARRANTY',
            text: 'Garantie'
        }]
    }

    get fuelLevels() {
        return [{
            value: '<= 10%',
            text: '<= 10%'
        },{
            value: '25%',
            text: '25%'
        },{
            value: '50%',
            text: '50%'
        },{
            value: '75%',
            text: '75%'
        },{
            value: '>= 75%',
            text: '>= 75%'
        }]
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download/file`
    }
}
